import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '../lib/api-error';

/**
 * Shared query defaults.
 *
 * Retries are deliberately conservative: a 4xx from the API means the request
 * itself was wrong, so repeating it only adds load and delays the error the
 * user needs to see.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError && !error.isRetryable) {
            return false;
          }

          return failureCount < 2;
        },
        retryDelay: (attemptIndex) => Math.min(1_000 * 2 ** attemptIndex, 8_000),
      },
      mutations: {
        retry: false,
      },
    },
  });
}
